window.VegasCatalog.WaitingList = {
	add: function (id) {
		let params = {
			product_id: id,
			_token: App.csrf
		};

		$.post('/waiting_list/add', params, function () {

		});
	},
	del: function (id) {
		let params = {
			product_id: id,
			_token: App.csrf
		};

		$.post('/waiting_list/del', params, function () {

		});
	},
}
$(document).ready(function () {
	$(document).on('click', '[data-product] [data-waiting-list][data-action="add"]', function () {
		let $item = $(this).closest('[data-product]');
		let $btn = $(this);
		let id = $item.data('id');

		VegasCatalog.WaitingList.add(id);

		$item.add('in-waiting-list')
		$btn.text('В листе ожидания');
		$btn.attr('data-action', '');

		let title = $btn.data('title') || 'Товар';
		VegasCatalog.popup(`${title} добавлен в лист ожидания`);

		return false;
	});

	$(document).on('click', '[data-product-item] [data-waiting-list][data-action="add"]', function () {
		let $item = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let id = $item.data('id');

		VegasCatalog.WaitingList.add(id);

		$btn.text('В листе ожидания');
		$btn.attr('data-action', '');

		let title = $btn.data('title') || 'Товар';
		VegasCatalog.popup(`${title} добавлен в лист ожидания`);

		return false;
	});

	$(document).on('click', '[data-product-item] [data-waiting-list][data-action="del"]', function () {
		let $item = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let id = $item.data('id');

		VegasCatalog.WaitingList.del(id);

		$btn.text('Убрано');

		let title = $btn.data('title') || 'Товар';
		VegasCatalog.popup(`${title} убран из листа ожидания`);

		return false;
	});

	$(document).on('click', '[data-order-product-item] [data-waiting-list][data-action="add"]', function () {
		let $item = $(this).closest('[data-order-product-item]');
		let $btn = $(this);
		let id = $item.data('id');

		VegasCatalog.WaitingList.add(id);

		$btn.text('В листе ожидания');
		$btn.attr('data-action', '');

		let title = $btn.data('title');
		VegasCatalog.popup(`${title} добавлен в лист ожидания`);

		return false;
	});
});
